import { FieldTypeContactForm, ContactFormProps } from "~/types/types"
import { slugPattern } from "~/utils/validationPatterns"
import { Form, Input } from "antd"
import React from "react"
import { t } from "~/languages/i18n"

const FormContact: React.FC<ContactFormProps> = ({ form, onFinishFailed, onFinish }) => {
  return (
    <Form
      form={form}
      className="w-[83%]"
      name="contact"
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
      layout="vertical"
    >
      <Form.Item<FieldTypeContactForm>
        label={<span className="text-base font-medium">{t("Name Form")}</span>}
        name="nameContact"
        rules={[{ required: true, message: t("Please input the contact name!") }]}
        className="!mb-0"
      >
        <Input placeholder={t("Contact Name")} className="py-2 text-xl custom-input" />
      </Form.Item>

      <div className="flex space-x-4 mb-4">
        <Form.Item<FieldTypeContactForm>
          label={<span className="text-base font-medium">{t("First Name")}</span>}
          name="firstName"
          rules={[{ required: true, message: t("Please input the first name!") }]}
          className="!mb-0 w-1/2"
        >
          <Input placeholder={t("First Name")} className="py-2 text-xl custom-input" />
        </Form.Item>

        <Form.Item<FieldTypeContactForm>
          label={<span className="text-base font-medium">{t("Last Name")}</span>}
          name="lastName"
          rules={[{ required: true, message: t("Please input the last name!") }]}
          className="!mb-0 w-1/2"
        >
          <Input placeholder={t("Last Name")} className="py-2 text-xl custom-input" />
        </Form.Item>
      </div>

      <div className="flex space-x-4 mb-4">
        <Form.Item<FieldTypeContactForm>
          label={<span className="text-base font-medium">{t("Email")}</span>}
          name="email"
          rules={[
            { required: true, message: t("Please input the email!") },
            { type: "email", message: t("Please input a valid email!") },
          ]}
          className="!mb-0 w-1/2"
        >
          <Input placeholder={t("Email")} className="py-2 text-xl custom-input" />
        </Form.Item>

        <Form.Item<FieldTypeContactForm>
          label={<span className="text-base font-medium">{t("Phone Number")}</span>}
          name="numberPhone"
          rules={[{ required: true, message: t("Please input the phone number!") }]}
          className="!mb-0 w-1/2"
        >
          <Input placeholder={t("Phone Number")} className="py-2 text-xl custom-input" />
        </Form.Item>
      </div>

      <Form.Item<FieldTypeContactForm>
        name="slug"
        rules={[
          {
            pattern: slugPattern,
            message: t('Slug must match the following: "A-Z, a-z, 0-9, - ,_ ,. ,~"'),
          },
        ]}
        label={<span className="text-base font-medium">{t("Slug")}</span>}
        extra={<span className="text-sm">{t("May not need to be entered (automatically rendered by name)")}</span>}
      >
        <Input placeholder={t("Slug")} className="py-2 custom-input" />
      </Form.Item>

      <Form.Item<FieldTypeContactForm>
        name="message"
        rules={[{ required: true, message: t("Please input the message!") }]}
        label={<span className="text-base font-medium">{t("Message")}</span>}
      >
        <Input.TextArea placeholder={t("Message")} className="py-2 custom-input" rows={4} />
      </Form.Item>
    </Form>
  )
}

export default FormContact
